import React from 'react';
import BaseComponent from '../../../../../baseClasses/BaseComponent';

import CompletionStepUtil from '../../../../../helpers/CompletionStepUtil/CompletionStepUtil';
import dataModel from '../../../../../models/DataModel';
import FileUtil from '../../../../../helpers/FileUtil/FileUtil';
import AnalyticsLogger from '../../../../../helpers/analytics/analyticsLogger';  

import instructionsIcon from '../../../../../assets/images/cs_quick_instructions.svg';
import inspectionYesIcon from '../../../../../assets/images/answer-yes.svg';
import inspectionNoIcon from '../../../../../assets/images/answer-no.svg';
import inspectionNAIcon from '../../../../../assets/images/answer-na.svg';
import inspectionYesSelectedIcon from '../../../../../assets/images/answer-yes-selected-small.svg';
import inspectionNoSelectedIcon from '../../../../../assets/images/answer-no-selected-small.svg';
import inspectionNASelectedIcon from '../../../../../assets/images/answer-na-selected-small.svg';
import noPhotoRequiredUnSelectedIcon from '../../../../../assets/images/no-photo-required_unselected_icon.svg';
import photoQueueIcon from '../../../../../assets/images/photo-queue.svg';
import checkoffDefault from '../../../../../assets/images/checkoff-default.svg';
import checkoffChecked from '../../../../../assets/images/checkoff-checked.gif';
import bluePlusButton from '../../../../../assets/images/add-blue-button.svg';
import formIcon from '../../../../../assets/images/forms-blue-icon.svg';
import undoNaIcon from '../../../../../assets/images/na-undo.svg';
import addPhotoIcon from '../../../../../assets/images/photo-circle-blue.svg';

import PhotoUtil from '../../../../../helpers/PhotoUtil/PhotoUtil';
import PhotoUtilPlugin from '../../../../../helpers/PhotoUtilPlugin/PhotoUtilPlugin';
import MiscConstants from '../../../../../constants/MiscConstants';
import ProgressIndicator from '../../../../../components/ProgressIndicator';
import CompletionStepPermissionsUtil from '../../../../../helpers/permissions/CompletionStepPermissionsUtil';
import FileUploadPreview from '../../../../../components/TaskCompletionStepsMobile/PhotoUpload/FileUploadPreview/';
import Animate from '../../../../../components/Animate';

import './CompletionStepQuickActions.scss';

export default class CompletionStepQuickActions extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      completionStep: props.completionStep,
      actionQueue: [],
      displayUploadButtons: false,
      numberButtons: 0,
      previewFile: null,
    };

    this.assembleQuickActions = this.assembleQuickActions.bind(this);
    this.toggleUploadButtons = this.toggleUploadButtons.bind(this);
    this.createPhotoFileUpload = this.createPhotoFileUpload.bind(this);
    this.createInspectionActions = this.createInspectionActions.bind(this);
    this.buttonGeneratorWithProgress = this.buttonGeneratorWithProgress.bind(this);
    this.isImage = this.isImage.bind(this);
    this.navigateToCS = this.navigateToCS.bind(this);
    this.handleUploadConfirm = this.handleUploadConfirm.bind(this);
    this.handleUploadCancel = this.handleUploadCancel.bind(this);
    this.updateFileCallback = this.updateFileCallback.bind(this);
    this.analyticsLogger = new AnalyticsLogger({ currentRole: null, isMobile: !!window.cordova });
    this.attachmentCount = props.completionStep.attachments ? props.completionStep.attachments.length : 0;
    this.maxAttachments = ['jpg','png'].indexOf(props.completionStep.requested_file_type) >= 0 ? MiscConstants.MAX_NUMBER_OF_PHOTOS : MiscConstants.MAX_NUMBER_OF_FILES;
  }

  componentDidMount() {
    this.assembleQuickActions(this.state.completionStep);
  }

  componentDidUpdate(prevProps, prevState) {
    //reset attachmentCount on completion step update
    if (prevProps.completionStep.attachments.length != this.props.completionStep.attachments.length) {
      this.attachmentCount = this.props.completionStep.attachments.length;
    }

    if (prevProps.completionStep != this.props.completionStep) {
      this.setState({ completionStep: this.props.completionStep });
      this.assembleQuickActions(this.props.completionStep);
    }
    else if (prevState.completionStep != this.state.completionStep) {
      this.assembleQuickActions(this.state.completionStep);
    }
    else if (prevState.loadingImage != this.state.loadingImage) {
      this.assembleQuickActions(this.props.completionStep);
    }
  }

  isImage(requested_file_type) {
    return requested_file_type == 'png' || requested_file_type == 'jpeg' || requested_file_type == 'jpg' || requested_file_type == 'gif';
  }

  assembleQuickActions(completionStep) {
    let actionQueue = [];

    switch (completionStep.completion_type) {
    case 'file_upload':
      if (this.isImage(completionStep.requested_file_type)) {
        actionQueue = this.createPhotoFileUpload(actionQueue, completionStep);
      }
      else {
        actionQueue = this.createFileUpload(actionQueue, completionStep);
      }
      break;
    case 'inspection':
      actionQueue = this.createInspectionActions(actionQueue, completionStep);
      break;
    case 'boolean':
      actionQueue = this.createCheckoffActions(actionQueue, completionStep);
      break;
    case 'form':
      actionQueue = this.createFormActions(actionQueue, completionStep);
      break;
    default:
      break;
    }

    actionQueue = this.createInstructions(actionQueue);

    this.setState({ actionQueue });
  }

  buttonGenerator(clickHandler, imgSrc) {
    return (
      <div className='quick-action-button' key={imgSrc} onClick={clickHandler}>
        <img className='queue-icon' src={imgSrc} alt='action queue button' />
      </div>
    );
  }

  buttonGeneratorWithProgress(clickHandler, imgSrc) {
    return (
      <div className='quick-action-button' key={imgSrc} onClick={clickHandler}>
        <ProgressIndicator/>
        <img className='queue-icon' src={imgSrc} alt='loading queue action' />
      </div>
    );
  }

  photoButton() {
    return this.buttonGenerator(this.toggleUploadButtons, addPhotoIcon);
/*
    return (
      <div className='quick-action-button' key={"add-photo" + this.state.completionStep.id} onClick={e => { e.stopPropagation() }}>
        <label htmlFor={"imageUpload" + this.state.completionStep.id} className="photo-add-button" key="add-button">
          <input id={"imageUpload" + this.state.completionStep.id} type="file" onChange={this.handleMultipleFileSelection} accept="image/*" multiple />
        </label>
      </div>
    )
*/
  }

  photoButtonWithProgress() {
    this.buttonGeneratorWithProgress(this.toggleUploadButtons, addPhotoIcon);
/*
    return (
      <div className='quick-action-button' key={"add-photo-progress" + this.state.completionStep.id} onClick={e => { e.stopPropagation() }}>
        <ProgressIndicator/>
        <label htmlFor={"imageUploadProgress" + + this.state.completionStep.id} className="photo-add-button" key="add-button">
          <input id={"imageUploadProgress" +  + this.state.completionStep.id} type="file" onChange={this.handleMultipleFileSelection} accept="image/*" multiple />
        </label>
      </div>
    )
*/
  }

  createFileUpload(actionQueue, completionStep) {
    const { userStepPermissions } = this.props;
    if (!completionStep.not_applicable) {
      if (this.state.loadingImage) {
        this.setState({ wasLoadingImage: true });
        actionQueue.push(this.buttonGeneratorWithProgress(() => {}, bluePlusButton));
      }
      else if (completionStep.attachments.length < this.maxAttachments) {
        actionQueue.push(this.buttonGenerator((e) => this.handleFileUpload(e), bluePlusButton));
      }

      if (!completionStep.attachments.length) {
        actionQueue.push(this.buttonGenerator((e) => this.handleNotApplicableButton(e), noPhotoRequiredUnSelectedIcon));
      }
    } 
    else if (
      (userStepPermissions.has('step_complete') || userStepPermissions.has('step_update')) && 
      !completionStep.reviewed_at && !completionStep.approved_at &&
      completionStep.status != 'completed'
    ) {
      actionQueue.push(this.buttonGenerator(e => this.handleUndoNotApplicable(e), undoNaIcon));
    }
    return actionQueue;
  }

  createPhotoFileUpload(actionQueue, completionStep) {
    const { userStepPermissions } = this.props;
    if (!completionStep.not_applicable) {
      if (this.state.loadingImage) {
        this.setState({ wasLoadingImage: true });
        actionQueue.push(this.photoButtonWithProgress());
        actionQueue.push(this.createPhotoQueueButton());
      }
      else {
        if (Math.max(this.attachmentCount, completionStep.attachments.length) < this.maxAttachments) {
          actionQueue.push(this.photoButton());
        }
        if (completionStep.attachments && (completionStep.attachments.length || this.state.wasLoadingImage)) {
          actionQueue.push(this.createPhotoQueueButton());
        }
        else if (!this.state.wasLoadingImage) {
          actionQueue.push(this.buttonGenerator((e) => this.handleCompleteStep(e, 'N/A'), noPhotoRequiredUnSelectedIcon));
        }
      }
    }
    else if (
      (userStepPermissions.has('step_complete') || userStepPermissions.has('step_update')) && 
      !completionStep.reviewed_at && !completionStep.approved_at &&
      completionStep.status != 'completed'
    ) {
      actionQueue.push(this.buttonGenerator(e => this.handleUndoNotApplicable(e), undoNaIcon));
    }
    return actionQueue;
  } 

  createInspectionActions(actionQueue, completionStep) {
    if (!completionStep.completed_at) {
      actionQueue.push(this.buttonGenerator((e) => this.handleInspectionCompleteStep(e, 'YES'), inspectionYesIcon));
      actionQueue.push(this.buttonGenerator((e) => this.handleInspectionCompleteStep(e, 'NO'), inspectionNoIcon));
      actionQueue.push(this.buttonGenerator((e) => this.handleInspectionCompleteStep(e, 'N/A'), inspectionNAIcon));
      if (completionStep.attachments && completionStep.attachments.length) 
      {
        actionQueue.push(this.createPhotoQueueButton());
      }
    }
    else {
      const { response } = completionStep;
      let icon = (response == 'NO' ? inspectionNoSelectedIcon : (response == 'YES' ? inspectionYesSelectedIcon : inspectionNASelectedIcon));
      actionQueue.push(this.buttonGenerator((e) => this.handleInspectionCompleteStep(e), icon));
      if (completionStep.attachments && completionStep.attachments.length) {
        actionQueue.push(this.createPhotoQueueButton());
      }
      else if (this.state.loadingImage) {
        actionQueue.push(this.photoButtonWithProgress());
      }
      if (Math.max(this.attachmentCount, completionStep.attachments.length) < this.maxAttachments) {
        actionQueue.push(this.photoButton());
      }
    }
    return actionQueue;
  }

  createCheckoffActions(actionQueue, completionStep) {
    if (!completionStep.completed_at) {
      actionQueue.push(this.buttonGenerator((e) => this.handleCheckoffCompleteStep(e, true), checkoffDefault));
      actionQueue.push(this.buttonGenerator((e) => this.handleNotApplicableButton(e), noPhotoRequiredUnSelectedIcon));
    }
    else {
      if (completionStep.not_applicable) {
        actionQueue.push(this.buttonGenerator(e => this.handleUndoNotApplicable(e), undoNaIcon));
      }
      else{
        actionQueue.push(this.buttonGenerator((e) => this.handleCheckoffCompleteStep(e, false), checkoffChecked));
      }
    }

    return actionQueue;
  }

  createFormActions(actionQueue, completionStep) {
    const { userStepPermissions } = this.props;
    if (!completionStep.not_applicable) {
      //add the form icon
      const formButton = (
        <div
          key={completionStep.id + '-forms'}
          className='quick-action-button quick-action-button__instructions'
          onClick={() => this.navigateToCS('QuickActionForm')}
        >
          <img src={formIcon} alt='form queue button' />
        </div>
      );
      actionQueue.push(formButton);
      //add the na icon
      actionQueue.push(this.buttonGenerator((e) => this.handleNotApplicableButton(e), noPhotoRequiredUnSelectedIcon));
    }
    else if (
      (userStepPermissions.has('step_complete') || userStepPermissions.has('step_update')) && 
      !completionStep.reviewed_at && !completionStep.approved_at &&
      completionStep.status != 'completed'
    ) {
      //if na'd show the selected na icon
      actionQueue.push(this.buttonGenerator(e => this.handleUndoNotApplicable(e), undoNaIcon));
    }
    return actionQueue;
  }

  createInstructions(actionQueue) {
    const { completionStep } = this.state;

    const instructions = (
      <div 
        key={completionStep.id + '-instructions'}
        className='quick-action-button quick-action-button__instructions' 
        onClick={() => this.navigateToCS('QuickActionsInfo') }
      >
        <img src={instructionsIcon} alt='instructions queue button'/>
          {
            completionStep.comments.length > 0 &&
            <div className='comment-count'>
             {completionStep.comments.length}
            </div>
          }
      </div>
    );

    actionQueue.push(instructions);
    return actionQueue;
  }

  navigateToCS(label) {
    this.analyticsLogger.logGenericCSEvent(label);
    this.props.navigateToCS();
  }

  handleDisplayPhotoCarousel(){
    if (this.props.displayPhotoCarousel){
      this.props.displayPhotoCarousel(this.props.task, this.state.completionStep);
      this.analyticsLogger.logGenericCSEvent('QuickActionsPhotoQ');
    }
  }

  createPhotoQueueButton() {
    const { completionStep } = this.state;
    let photoQueue = (
      <div onClick={this.handleDisplayPhotoCarousel}
        className='quick-action-button quick-action-button__photo-queue'
        key={completionStep.id + '-photoQueue'}
      >
        <img className='queue-icon queue-icon__photo-queue' src={ photoQueueIcon } alt='Queued' />
        <div className='queue-photo-count'>
          { completionStep.attachments.length }
        </div>
      </div>
    );
    return photoQueue;
  }

  handleInspectionCompleteStep(e, response) {
    this.handleCompleteStep(e, response);
  }

  handleCheckoffCompleteStep(e, response) {
    this.handleCompleteStep(e, response);
  }

  handleNotApplicableButton(e) {
    e.stopPropagation();
    const { completionStep } = this.state;

    if (completionStep.completion_type == 'form' || completionStep.completion_type == 'boolean') {
      const responseFound = completionStep.form_fields.find(field => field.response && field.response[0]);
      if (responseFound) {
        dataModel.showGlobalModal('SYSTEM_POPUP', {
          height: 184,
          width: 320,
          message: this.textMap.markPartialFormAsNA,
          cancelButtonText: 'Cancel',
          okButtonText: 'Yes',
          handleOwnerOk: () => {
            this.handleNotApplicable(e);
          },
          handleOwnerCancel: () => { },
        });
      }
      else {
        this.handleNotApplicable(e);
      }
    }
    else {
      this.handleNotApplicable(e);
    }
  }

  handleNotApplicable(e) {
    e.stopPropagation();
    const { completionStep } = this.state;
    completionStep.completed_at = new Date().toJSON();
    completionStep.not_appicable = true;
    this.setState({ completionStep });
    this.props.updateCallback(completionStep);
    CompletionStepUtil.handleCSNotApplicableButton(completionStep, this.analyticsLogger)
      .catch(error => {
        // roll back NA
        completionStep.completed_at = null;
        completionStep.not_applicable = null;
        this.props.updateCallback(completionStep);
        this.setState({ completionStep });
      });
    
  }

  handleUndoNotApplicable(e) {
    e.stopPropagation();
    const { completionStep } = this.state;
    const completedDate = completionStep.completed_at;
    completionStep.completed_at = null;
    completionStep.not_applicable = null;
    this.props.updateCallback(completionStep);
    this.setState({ completionStep });
    CompletionStepUtil.handleCSUndoNotApplicableButton(completionStep, this.analyticsLogger)
      .catch(error => {
        // roll back
        completionStep.completed_at = completedDate;
        completionStep.not_applicable = true;
        this.props.updateCallback(completionStep);
        this.setState({ completionStep });
      });
  }

  handleCompleteStep(e, response) {
    e.stopPropagation();
    const { completionStep } = this.state;
    const { task, userStepPermissions } = this.props;
    if (CompletionStepPermissionsUtil.canCompleteStep(task, completionStep)) {
      if (completionStep.not_applicable && (response || userStepPermissions.has('override'))) {
        CompletionStepUtil.handleAnswerSelected(completionStep, response, this.props.updateCallback);
      }
      else {
        CompletionStepUtil.handleAnswerSelected(completionStep, response, this.props.updateCallback);
      }
    }
  }

  handleFileUpload(e) {
    e.stopPropagation();
    e.preventDefault();
    const { completionStep } = this.state;
    const { task } = this.props;
    this.analyticsLogger.logGenericCSEvent('QuickActionsFileUpload');
    FileUtil.handleMobileFileUpload(completionStep, task, this.handleToggleLoading, this.updateFileCallback);
  }

  updateFileCallback(status, updateObject) {
    if (status == 'persist') {
    } else if (status == 'error') {
      dataModel.displayInfoErrorMessage('An unexpected error was encountered processing the file.', 4000, 2, null);
    } else if (status == 'created') {
      this.props.updateCallback(updateObject);
    }
  }

  handleToggleLoading(loadingImage) {
    this.setState({ loadingImage });    
  }  

  toggleUploadButtons(e) {
    e.stopPropagation();
    
    const { completionStep } = this.state;
    if (!this.previewFile && Math.max(this.attachmentCount, completionStep.attachments.length) < this.maxAttachments) {
      this.setState({ displayUploadButtons: !this.state.displayUploadButtons });
    }
  }

  handleCloseUpLoadButtons() {
    this.setState({ displayUploadButtons: false, hideUploadButtons: false });
  }

  handleCancelComment() {
  }

  async handleMultipleFileSelection(e) {
    e.stopPropagation();
    e.preventDefault();

    const { completionStep } = this.state;
    const { task } = this.props;
    const files = e.target.files;

    if (!files.length) {
      return;
    }
    else {
      this.setState({ loadingImage: true });
      const updatedCS = await PhotoUtil.selectMultipleFiles(files, true, completionStep, task);
      updatedCS.completed_at = new Date().toJSON();
      this.props.updateCallback(updatedCS);
      this.assembleQuickActions(updatedCS);
      this.setState({
        completionStep: updatedCS ? updatedCS : completionStep,
        loadingImage: false,
      });

      //analytics
      if (completionStep.completion_type == 'inspection') {
        this.analyticsLogger.logGenericCSEvent('QuickActionsInspectionPhoto');
      }
      else {
        this.analyticsLogger.logGenericCSEvent('QuickActionsPhoto');
      }
    }
  }

  handleMobileImage(e) {
    e.stopPropagation();
    e.preventDefault();
    const uploadMethod = e.target.name;

    if (navigator && navigator.camera) {
      this.handleCancelButton(e);
      this.setState({ uploadMethod }, () => {
        PhotoUtilPlugin.captureMobileImage(uploadMethod, false, () => {
        })
        .then((fileinfo) => {
          if (uploadMethod == 'library') {
            this.setState({ previewFile: fileinfo });
          } else {
            this.finishUpload(fileinfo);
          }
        })
        .catch((error) => {
        });
      });
    }
  }

  finishUpload(fileinfo) {
    const { completionStep } = this.state;
    const { task } = this.props;
    const { file, fileExtension, resizedImage, exifData } = fileinfo;
    PhotoUtilPlugin.handleSaveFile(file, fileExtension, resizedImage, exifData, completionStep, task)
    .then((updatedStep) => {
      this.setState({ completionStep: updatedStep });
    })
    .catch((error) => {
    });
  }

  handleUploadConfirm(e) {
    e.stopPropagation();
    this.finishUpload(this.state.previewFile);
    this.handleUploadCancel(e);
  }

  handleUploadCancel(e) {
    e.stopPropagation();
    this.handleCloseUpLoadButtons();
    this.setState({ previewFile: null, uploadMethod: null });
    this.previewFile = null;
  }

  handleCancelButton(e) {
    this.toggleUploadButtons(e);
    this.setState({
      hideUploadButtons: true,
    });
  }

  render() {
    let animate, uploadButtons, background;

    if (this.state.displayUploadButtons) {
      background = <div className="photo-background-disable" onClick={this.handleCancelComment} />;

      animate = (
        <Animate
         component_id="upload-buttons"
         key="upload-buttons"
         property={{ bottom: { startVal: -213, endVal: 0 } }}
         duration={250}
        />
      );
      uploadButtons = (
        <div className="upload-options" id="upload-buttons">
          <div className="outerbox">
            <button name="library" ref="library" className="upload-button top-button" onClick={this.handleMobileImage}>Upload File</button>
            <button name="camera" onClick={this.handleMobileImage} className="upload-button">Use Camera</button>
          </div>
          <div className="cancel-button" onClick={this.handleCancelButton}>
            Cancel
          </div>
        </div>
      );
    }
    return (
      <div className='CompletionStepQuickActions' key={'cs-quick-actions' + this.state.completionStep.id}>
        { animate }
        { background }
        { this.state.actionQueue }
        { uploadButtons }
        {this.state.previewFile &&
          <FileUploadPreview
            fileToPreview={this.state.previewFile}
            handleUploadConfirm={this.handleUploadConfirm}
            handleUploadCancel={this.handleUploadCancel}
          />
        }
      </div>
    ); 
  }
}




// WEBPACK FOOTER //
// ./src/containers/TasksContainer/MobileTaskDetails/TaskCompletionSteps/CompletionStepQuickActions/index.js